import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import $ from 'jquery';
import {Row,Col} from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {Slider, CategoryWidget, FeaturedProduct, ProductCollection, LineLoader, NewsScroll} from '../../elements';
import API from '../../../utils/API';
import {Api} from '../../../utils/Variables';
import {getCookieField} from '../../../utils';


class Home extends Component{
	constructor(props){
		super(props);
		this.state = {
			featureProducts: [],
		}
	}
	
	componentDidMount(){
		//this.loadFeatureProducts();
	}
	
	loadFeatureProducts(){
		try{
			API.get('v1/site/item/featured/4').then(res=>{
				if(res['data'].status=='1')
				{
					this.setState({featureProducts: res['data'].data});
				}
			});						
		}
		catch(error){
			console.log(error);
		}
	}
	
	
	
	render(){
		
		
		return(
			<div>
				
				
				
				
				
			</div>
		);
	}
	
}
export default Home;
